import React from 'react';
import { routes, Page } from './model';
import { ViewerPage } from '../viewer/components/ViewerPage';
import { PackPage } from '../pack/components/PackPage';
import { FavoritesPage } from '../favorite/components/FavoritesPage';
import { SharingPage } from '../sharing/components/SharingPage';
import { SharingLinksPage } from '../sharingLink/components/SharingLinksPage';
import { GeneralRoutes, RouteDecl } from '../../../general/modules/router/components/Routes';
import { HashRouter as Router } from 'react-router-dom';
import { UploadGuard } from '../uploader/components/UploadGuard';

const ROUTES: RouteDecl[] = [
  {
    key: Page.viewer,
    page: Page.viewer,
    props: {
      path: routes.viewer,
      exact: false,
      component: ViewerPage,
    },
  },
  {
    key: Page.pack,
    page: Page.pack,
    props: {
      path: routes.pack,
      exact: false,
      component: PackPage,
    },
  },
  {
    key: Page.favorite,
    page: Page.favorite,
    props: {
      path: routes.favorite,
      exact: false,
      component: FavoritesPage,
    },
  },
  {
    key: Page.sharing,
    page: Page.sharing,
    props: {
      path: routes.sharing,
      exact: false,
      component: SharingPage,
    },
  },
  {
    key: Page.sharingLinks,
    page: Page.sharingLinks,
    props: {
      path: routes.sharingLinks,
      exact: false,
      component: SharingLinksPage,
    },
  },
];

export const Routes = () => <GeneralRoutes routes={ROUTES} defaultUrl={routes.viewer} />;

export const AssetLabRouter = () => (
  <Router>
    <UploadGuard />
    <Routes />
  </Router>
);
